import { render, staticRenderFns } from "./FDecimal.vue?vue&type=template&id=0183fd57&"
import script from "./FDecimal.vue?vue&type=script&lang=js&"
export * from "./FDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports